var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejectShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.916 68.2074C391.515 68.2072 336.837 48.7747 293.087 13.1815C271.485 -4.39317 240.515 -4.39317 218.913 13.1815C175.163 48.7751 120.485 68.2077 64.0853 68.2074C46.4735 68.2074 32.1968 82.4842 32.1968 100.096V185.562C32.1968 295.201 81.5666 399.013 166.616 468.206L192.865 489.561C229.64 519.48 282.364 519.48 319.139 489.561L345.388 468.206C430.436 399.014 479.807 295.197 479.807 185.558V100.089C479.804 82.4772 465.527 68.2074 447.916 68.2074Z",
    fill: "url(#paint0_linear_140_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 483.863C249.833 483.856 243.856 481.732 239.069 477.845L188.864 437C152.193 407.165 122.078 368.83 101.774 326.138C81.4712 283.446 70.7393 235.892 70.7393 188.619V120.796C70.7393 112.591 77.4475 105.613 85.6415 105.181C141.517 102.226 195.535 81.5062 239.069 46.0878C243.856 42.201 249.833 40.0766 256 40.0703C262.166 40.0763 268.144 42.2003 272.931 46.0868C316.467 81.5062 370.486 102.226 426.361 105.181C434.553 105.613 441.261 112.59 441.261 120.794V188.615C441.261 235.889 430.529 283.443 410.225 326.136C389.922 368.83 359.807 407.165 323.137 437L272.931 477.845C268.144 481.733 262.167 483.857 256 483.863Z",
    fill: "url(#paint1_linear_140_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 465.139C250.354 465.133 244.881 463.188 240.497 459.63L194.529 422.232C160.953 394.915 133.379 359.814 114.789 320.725C96.1998 281.636 86.3734 238.095 86.3734 194.81V132.711C86.3734 125.198 92.5154 118.81 100.018 118.413C151.178 115.707 200.638 96.7361 240.497 64.3064C244.881 60.7477 250.354 58.8024 256 58.7959C261.646 58.8015 267.119 60.7466 271.502 64.3054C311.363 96.7361 360.824 115.707 411.984 118.413C419.486 118.809 425.627 125.196 425.627 132.708V194.805C425.627 238.09 415.8 281.631 397.211 320.722C378.621 359.813 351.047 394.914 317.471 422.231L271.502 459.629C267.119 463.188 261.646 465.134 256 465.139Z",
    fill: "url(#paint2_linear_140_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 385.479C329.191 385.479 388.525 326.145 388.525 252.954C388.525 179.763 329.191 120.429 256 120.429C182.809 120.429 123.475 179.763 123.475 252.954C123.475 326.145 182.809 385.479 256 385.479Z",
    fill: "url(#paint3_linear_140_49)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_140_49)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.215 289.877L294.906 242.154L332.626 204.409C336.067 200.953 338 196.273 338 191.393C338 186.514 336.067 181.834 332.626 178.378C329.172 174.934 324.495 173 319.619 173C314.743 173 310.066 174.934 306.612 178.378L269.001 216.123L221.202 263.846L183.483 301.591C180.041 305.047 178.108 309.727 178.108 314.607C178.108 319.486 180.041 324.166 183.483 327.622C186.936 331.066 191.613 333 196.489 333C201.365 333 206.042 331.066 209.496 327.622L247.215 289.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.906 263.846L247.215 216.123L209.388 178.378C205.934 174.934 201.257 173 196.381 173C191.505 173 186.828 174.934 183.374 178.378C179.933 181.834 178 186.514 178 191.393C178 196.273 179.933 200.953 183.374 204.409L221.094 242.045L268.785 289.877L306.504 327.622C309.958 331.066 314.635 333 319.511 333C324.387 333 329.064 331.066 332.517 327.622C335.959 324.166 337.892 319.486 337.892 314.607C337.892 309.727 335.959 305.047 332.517 301.591L294.906 263.846Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_140_49",
    x: 178,
    y: 172,
    width: 175,
    height: 170,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.448333 0 0 0 0 0.448333 0 0 0 0 0.448333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_140_49"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_140_49",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_140_49",
    x1: 68.4845,
    y1: 24.1714,
    x2: 454.458,
    y2: 410.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A578D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_140_49",
    x1: 507.854,
    y1: 469.685,
    x2: 166.348,
    y2: 128.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#93CEF6",
    stopOpacity: 0.243
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#6ABFEC",
    stopOpacity: 0.576
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#51B5E5",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_140_49",
    x1: 189.971,
    y1: 155.527,
    x2: 339.987,
    y2: 305.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_140_49",
    x1: 194.36,
    y1: 191.315,
    x2: 322.096,
    y2: 319.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92B2B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectShield);
export default __webpack_public_path__ + "static/media/RejectShield.227398199273ac82e3dc843925a410ef.svg";
export { ForwardRef as ReactComponent };